/* eslint-disable no-console */
import type { QueryKey } from '@tanstack/react-query';
import type { FC } from 'react';

import React from 'react';
import { createRoot } from 'react-dom/client';

import globalInvokes from '../../../globalFunctionInvokes';
import { getMicroAppInitialQueryData, setMicroAppInitialQueryData } from './renderMicroApp.utils';

export interface MicroAppProps<T extends object = object> {
    ssrData?: T;
    initialQueryData?: { key: QueryKey; data: unknown }[];
}

export const getMicroAppProps = <TProps>(container: HTMLElement) => {
    const domProps = container?.dataset?.reactProps;
    return domProps ? (JSON.parse(domProps) as TProps) : undefined;
};

const renderMicroApp = <T extends object = object>(microApp: FC<MicroAppProps<T>>) => {
    const container = document.querySelector<HTMLElement>('#reactMicroApp');
    const props = getMicroAppProps<T>(container!);

    globalInvokes();

    // critical to performance - set initial query data before creating the root of app
    setMicroAppInitialQueryData(getMicroAppInitialQueryData());

    const root = createRoot(container!);
    root.render(React.createElement(microApp, { ssrData: props }));
};

export const renderRootElement = (rootElement: React.JSX.Element) => {
    const container = document.querySelector<HTMLElement>('#reactMicroApp');
    const root = createRoot(container!);

    globalInvokes();

    root.render(rootElement);
};

export default renderMicroApp;
